module.exports = __webpack_public_path__ + "static/media/galerija_2014 (30).d74d29ef.jpg";